import { createBrowserRouter } from 'react-router-dom'
import App from './App'
import Toys from './routes/Toys'
import ToyDetail from './routes/ToyDetail'
import MakeMusicPlayer from './routes/MakeMusicPlayer'
import MakeABC from './routes/MakeABC'
import MakeMidiSynth from './routes/MakeMidiSynth'
import MakePodcastPlayer from './routes/MakePodcastPlayer'
import About from './routes/About'
import Login from './routes/Login'
import NotFound from './routes/NotFound'
import Admin from './routes/Admin'
import AdminUser from './routes/AdminUser'
import AdminTools from './routes/AdminTools'
import AdminToolGenerateAlphabet from './routes/AdminToolGenerateAlphabet'
import AdminToolMakeApp from './routes/AdminToolMakeApp'
import ProtectedRoute from './auth/ProtectedRoute'
import AdminRoute from './auth/AdminRoute'

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        element: <App />,
        children: [
          { index: true, element: <Toys /> },
          { path: 'toys/featured/:id', element: <ToyDetail source="featured" /> },
          { path: 'toys/my/:id', element: <ToyDetail source="mine" /> },
          // Legacy un-scoped URL, kept so old bookmarks keep resolving.
          { path: 'toys/:id', element: <ToyDetail /> },
          { path: 'make/music-player', element: <MakeMusicPlayer /> },
          { path: 'make/abc', element: <MakeABC /> },
          { path: 'make/midi-synth', element: <MakeMidiSynth /> },
          { path: 'make/podcast-player', element: <MakePodcastPlayer /> },
          { path: 'about', element: <About /> },
          { path: '*', element: <NotFound /> },
        ],
      },
    ],
  },
  {
    element: <AdminRoute />,
    children: [
      {
        path: '/admin',
        element: <App />,
        children: [
          { index: true, element: <Admin /> },
          { path: 'users/:identityId', element: <AdminUser /> },
          { path: 'users/:identityId/toys/:id', element: <ToyDetail /> },
          { path: 'users/:identityId/toys/:id/:version', element: <ToyDetail /> },
        ],
      },
      {
        path: '/admin-tools',
        element: <App />,
        children: [
          { index: true, element: <AdminTools /> },
          { path: 'generate-alphabet', element: <AdminToolGenerateAlphabet /> },
          { path: 'make-app', element: <AdminToolMakeApp /> },
        ],
      },
    ],
  },
])
